"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isResultsTableRowProperty = exports.resultsTableRowPropertyDefinition = void 0;
exports.resultsTableRowPropertyDefinition = {
    view: { label: 'Results Table Row' },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'orderedProperties',
            argument: [
                'results-table-row-cell-rank',
                'results-table-row-cell-person',
                'results-table-row-cell-main-result',
                'results-table-row-cells-additional',
            ],
        },
    ],
    type: 'ordered-container',
    multiple: true,
    name: 'results-table-row',
};
const isResultsTableRowProperty = (prop) => {
    return prop.name === exports.resultsTableRowPropertyDefinition.name;
};
exports.isResultsTableRowProperty = isResultsTableRowProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVzdWx0cy10YWJsZS1yb3cucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9yZXN1bHRzLXRhYmxlLXJvdy5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFNYSxRQUFBLGlDQUFpQyxHQUFHO0lBQy9DLElBQUksRUFBRSxFQUFFLEtBQUssRUFBRSxtQkFBbUIsRUFBRTtJQUNwQyxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxVQUFVO1lBQ2hCLFFBQVEsRUFBRSxJQUFJO1NBQ2Y7UUFDRDtZQUNFLElBQUksRUFBRSxtQkFBbUI7WUFDekIsUUFBUSxFQUFFO2dCQUNSLDZCQUE2QjtnQkFDN0IsK0JBQStCO2dCQUMvQixvQ0FBb0M7Z0JBQ3BDLG9DQUFvQzthQUNyQztTQUNGO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsbUJBQW1CO0lBQ3pCLFFBQVEsRUFBRSxJQUFJO0lBQ2QsSUFBSSxFQUFFLG1CQUFtQjtDQUNNLENBQUE7QUFXMUIsTUFBTSx5QkFBeUIsR0FBRyxDQUFDLElBQWtCLEVBQW1DLEVBQUU7SUFDL0YsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLHlDQUFpQyxDQUFDLElBQUksQ0FBQTtBQUM3RCxDQUFDLENBQUE7QUFGWSxRQUFBLHlCQUF5Qiw2QkFFckMifQ==